import React from "react";

import { View } from "react-native";

import Button from "components/Button";
import Icon from "components/Icon";
import Text from "components/Text";

import css from "styles";
import { mq } from "utils";
import { colors, sizes, strings } from "assets/constants";

type ILogoutAlertContent = {
  title?: string;
  descriptions?: string;
  description?: Array<{ b?: boolean; text: string }>;
  remove?: () => void;
  cancel?: () => void;
  removeLoading?: boolean;
};

export default function LogoutAlertContent(props: ILogoutAlertContent) {
  const { title, description, remove, cancel, removeLoading } = props;

  return (
    <View style={{ ...css.centralElements }}>
      <Icon color={colors.danger} name="trash-2" />

      <Text
        weight="medium"
        size={"xl"}
        align="center"
        style={{ marginVertical: mq(20) }}
      >
        {title || strings.are_you_sure_delete_this_item}
      </Text>

      {description && (
        <>
          <Text align="center" style={{ lineHeight: 25 }}>
            {description?.map((desc, index) => (
              <Text key={String(index)} weight={desc.b ? "bold" : "default"}>
                {desc.text}
              </Text>
            ))}
          </Text>
          <View style={{ marginBottom: mq(30) }} />
        </>
      )}

      <View
        style={{
          ...css.fitWidth,
          ...css.rowCenterAlign,
          ...css.justifySpaceEvenly,
        }}
      >
        <Button
          onPress={remove}
          loading={removeLoading}
          width={"40%"}
          bgColor={colors.danger}
          title={{ value: strings.be_removed, size: "sm" }}
        />
        <View style={{ width: sizes.space }} />
        <Button
          onPress={cancel}
          width={"40%"}
          outline
          bgColor={colors.danger}
          title={{ value: strings.cancel, size: "sm" }}
        />
      </View>
    </View>
  );
}
